const providersMap = {
  'Facebook Embed': 'facebook',
  'Instagram Embed': 'instagram',
  'Twitter Embed': 'twitter',
  'YouTube Embed': 'youtube',
  'Giphy': 'giphy'
};
const providers = Object.keys(providersMap);

export default function usercentrics(handler) {
  const ids = getConsentIds(handler);

  return {
    hasConsent,
    grantConsent,
    revokeConsent,
    openConsents
  };

  function hasConsent(name) {
    const consent = handler.getConsents(ids[name]);
    return !!(consent && consent.consentStatus);
  }

  function grantConsent(name) {
    updateConsent(name, true);
  }

  function revokeConsent(name) {
    updateConsent(name, false);
  }

  function updateConsent(name, status) {
    handler.updateConsents([{ templateId: ids[name], status }]);
  }

  function openConsents() {
    handler.toggleCornerModalIsVisible();
  }
}

function getConsentIds(handler) {
  return handler
    .getConsents()
    .reduce(getIds, {});
}

function getIds(ids, consent) {
  const provider = consent.dataProcessors[0];

  if (providers.includes(provider)) {
    ids[providersMap[provider]] = consent.templateId;
  }

  return ids;
}
